<template>
  <AlertInner>
    <BaseLoading/>
  </AlertInner>
</template>
<script>
import BaseLoading from '@/common/BaseLoading'
import AlertInner from './AlertInnerTransparent'

export default {
  components: {
    BaseLoading,
    AlertInner
  }
}
</script>
<style module lang="postcss">
.title {
  font-weight: bold;
  font-size: 1.2em;
  line-height: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Alert/AlertWithLoading.vue